
export default function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));


  const parseJwt = (token) => {
    localStorage.removeItem('sess');
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  const decodedJwt = parseJwt(user?.accessToken);
  if (decodedJwt?.exp * 1000 < Date.now()) {
    return localStorage.setItem("sess", JSON.stringify('inactive'));
  } else return { Authorization: "Bearer " + user?.accessToken };
}
